import script from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"
export * from "./my-upload-imgs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__